import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Axios } from "../../../Headers";

const WebBookContactForm = (props) => {
  const { bookId, handleResponse } = props;
  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      mobile: "",
      email: "",
      copy: "",
    },
    validationSchema: Yup.object({
      firstName: Yup.string()
        .required("First name is required")
        .min(2, "First name must be at least 2 characters"),
      lastName: Yup.string()
        .required("Last name is required")
        .min(2, "Last name must be at least 2 characters"),
      mobile: Yup.string()
        .required("Mobile number is required")
        .matches(/^[0-9]{10}$/, "Mobile number must be 10 digits"),
      email: Yup.string()
        .required("Email is required")
        .email("Invalid email address"),
      copy: Yup.number().required("Number of copies is required"),
    }),
    onSubmit: (values) => {
      console.log("Form Submitted", values);
      handleApiCall(values);
    },
  });

  const handleApiCall = (values) => {
    try {
      const fd = new FormData();
      fd.append("firstName", values.firstName);
      fd.append("lastName", values.lastName);
      fd.append("email", values.email);
      fd.append("mobile", values.mobile);
      fd.append("bookId", bookId);
      fd.append("copy", values.copy);
      Axios.post(
        "//" + window.$name + "/controller/AddWebBookContactController.php",
        fd
      )
        .then((res) => {
          console.log(res);
          if (res.data.Success === 1) {
            handleResponse(
              true,
              "Thank you for your interest! We will get back to you soon."
            );
          } else {
            handleResponse(
              false,
              "There was an error processing your request. Please try again later."
            );
          }
        })
        .catch((err) => {
          //console.log(err);
        });
    } catch (error) {
      console.error("API call failed:", error);
    }
  };

  return (
    <form onSubmit={formik.handleSubmit}>
      <center>
        <div className="row">
          <div className="col-lg-6 col-md-12">
            <div className="form-group">
              <input
                id="contact-input"
                type="text"
                placeholder="First Name"
                name="firstName"
                value={formik.values.firstName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.firstName && formik.errors.firstName ? (
                <div style={{ color: "red" }}>{formik.errors.firstName}</div>
              ) : null}
            </div>
          </div>

          <div className="col-lg-6 col-md-12">
            <div className="form-group">
              <input
                type="text"
                id="contact-input"
                name="lastName"
                placeholder="Last Name"
                value={formik.values.lastName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.lastName && formik.errors.lastName ? (
                <div style={{ color: "red" }}>{formik.errors.lastName}</div>
              ) : null}
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-6 col-md-12">
            <div className="form-group">
              <input
                type="tel"
                name="mobile"
                placeholder="Mobile"
                id="contact-input"
                value={formik.values.mobile}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.mobile && formik.errors.mobile ? (
                <div style={{ color: "red" }}>{formik.errors.mobile}</div>
              ) : null}
            </div>
          </div>

          <div className="col-lg-6 col-md-12">
            <div className="form-group">
              <input
                type="email"
                name="email"
                placeholder="Email"
                id="contact-input"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.email && formik.errors.email ? (
                <div style={{ color: "red" }}>{formik.errors.email}</div>
              ) : null}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6 col-md-12">
            <div className="form-group">
              <input
                type="number"
                name="copy"
                placeholder="Number of Copies"
                id="contact-input"
                value={formik.values.copy}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.copy && formik.errors.copy ? (
                <div style={{ color: "red" }}>{formik.errors.copy}</div>
              ) : null}
            </div>
          </div>
        </div>

        <button id="home-publish-btn" type="submit">
          Submit
        </button>
      </center>
    </form>
  );
};

export default WebBookContactForm;
